import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';

import {clientsService} from '@store/clients/clients.service';
import {ClientsState} from '@store/clients/clients.store';

type SearchClientsParams = Partial<ClientsState>

export const searchClientsEffect = createEffectFn((params$: Observable<SearchClientsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => clientsService.getClients().pipe(
      catchError(() => EMPTY)
    )),
  );
});
